// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-N53KwS","arrow":"arrow-FHtp_n"};